import React, { useEffect, useState } from "react";
import ReportTemplate2 from "../reportTemplate2";
import dayjs from "dayjs";
import { formatCurrency } from "../../../utils/Utils";
import purchaseOrderApis from "../../../api/purchase-orders/pruchaseOrderCreation";

function SupplierLedgerReport() {
  const [supplierOptions, setSupplierOptions] = useState<any>([]);

  useEffect(() => {
    fetchSupplierList();
  }, []);

  const fetchSupplierList = async () => {
    try {
      const res: any = await purchaseOrderApis.fetchBuyerLinkedSupplierListMethod();
      const { data, status } = res;
      if (status) {
        let _supplierOptions = data.map((item: any) => ({
          label: item?.sellerOrg?.name,
          value: item?.sellerOrg?.orgId?.toString(),
        }));
        setSupplierOptions(_supplierOptions);
      }
    } catch (error) {
      console.error("Error fetching supplier list:", error);
    }
  };

  const columns: any = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 150,
      render: (text: any) => {
        if (!text) return "N/A";
        // API returns date in format "21/01/2025", parse it correctly
        try {
          const dateParts = text.split("/");
          if (dateParts.length === 3) {
            // Format: DD/MM/YYYY
            return text; // Display as-is since it's already in DD-MM-YYYY format
          }
          // If it's a different format, try to parse with dayjs
          return dayjs(text).format("DD-MM-YYYY");
        } catch (error) {
          return text;
        }
      },
    },
    {
      title: "Particulars",
      dataIndex: "particulars",
      key: "particulars",
      width: 250,
    },
    {
      title: "Voucher No",
      dataIndex: "voucherNo",
      key: "voucherNo",
      width: 150,
    },
    {
      title: "Debit",
      dataIndex: "debit",
      key: "debit",
      width: 150,
      render: (text: any) => (
        <div style={{ textAlign: "right" }}>
          {text || "0.00"}
        </div>
      ),
    },
    {
      title: "Credit",
      dataIndex: "credit",
      key: "credit",
      width: 150,
      render: (text: any) => (
        <div style={{ textAlign: "right" }}>
          {text || "0.00"}
        </div>
      ),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      width: 150,
      render: (text: any) => (
        <div style={{ textAlign: "right" }}>
          {text || "0.00"}
        </div>
      ),
    },
  ];

  return (
    <ReportTemplate2
      pageTitle="Supplier Ledger"
      pageDescription="Track all financial transactions for supplier"
      moduleKey="supplierLedgerReport"
      columns={columns}
      filtersOption={{
        supplier: true,
      }}
      previousPath="/view-accounts-payable-reports"
      extra={{
        tableScrollX: 1000,
        supplierOptions: supplierOptions,
      }}
    />
  );
}

export default SupplierLedgerReport;
